import { MessageActions } from '../types';

export const handleMsgOnPayField = ({ event, setLibVersion, sessionId, libInitializeId }: {
  event: MessageEvent,
  setLibVersion: (libVersion: string) => void,
  sessionId: string,
  libInitializeId: string,
}) => {
  if (event.data.action === MessageActions.GET_VERSION) {
    setLibVersion(event.data.version);
    window.parent.postMessage({
      action: MessageActions.VERSION_RECEIVED,
      sessionId,
      libInitializeId,
    }, '*');
  }
};

export const handleMsgOnCommonField = (event: MessageEvent) => {
  const updateStyle = (event: MessageEvent) => {
    if ((typeof event.data.stylesCSS) !== 'string') return;
    const style = document.createElement('style');
    style.textContent = event.data.stylesCSS;
    document.head.appendChild(style);
  };

  if (event.data.action === MessageActions.UPDATE_STYLES) {
    updateStyle(event);
  }
};
